const termsData = {
  maintitle: `Terms and Conditions`,
  maincontent: [
    {
      para: `These terms and conditions (Terms & Conditions) are an agreement between the Website Operator ( “Acko General”, “us”, “we” or, “our”) and you, the visitor (“Visitor”, “Customer”, “User”, “you” or “your”). This Agreement sets forth the general Terms & Conditions of your use of the website [https://www.cko.com] and any of its products or services (collectively, “Website” or “Services”).`,
    },

    {
      para: `This Website is created in the interest of the general public who shall have access to the contents of this Website. By accessing this Website and using its content, you acknowledge and you agree that you have read and understood the following terms of use and you agree to be bound by them. These Terms & Conditions may be revised at any time by updating this posting. You are bound by any such revisions and therefore we advise you to review these Terms & Conditions every time you use this Website. Do not access, download materials from this Website, if you do not agree with these terms of use.`,
    },
  ],
  list: [
    {
      id: `tDl1`,
      title: `ACCEPTANCE OF TERMS & CONDITIONS`,
      paras: [
        {
          para: `You acknowledge that you have read and agree with all these Terms & Conditions. By using the Website or its Services, you agree to be bound by this Agreement. If you do not agree to abide by the terms of this Agreement, you are not authorized to use or access the Website and its Services. Acko General reserves the right to store information on a User’s computer in the form of “cookie” or similar file for purposes of modifying the Website to reflect the User’s preference.`,
        },
      ],
    },
    {
      id: `tDl2`,
      title: `CONSULTING SERVICES`,
      paras: [
        {
          para: `Any decisions to purchase any policy/product of Acko General will be based solely on the Visitor’s independent evaluation of the policies/products of Acko General, and his/her need for the same. The Visitor has the responsibility to determine whether the policies/products offered by Acko General satisfy the requirements of the Visitor. It is the responsibility of the Visitor to evaluate the completeness, accuracy or usefulness of any opinion, guidance or other content made available on the Website and the Visitor should consult his/its own legal counsel, business advisor and tax advisor as to the legal, business, tax and related matters concerning any policies with respect to which guidance is sought or given.`,
        },

        {
          para: `Acko General has provided the relevant information in relation to the policies/products on the Website.`,
        },
        {
          para: `In the event the Visitor requires any further information or assistance, he/she may contact us at support@acko.com`,
        },
      ],
    },
    {
      id: `tDl3`,
      title: `REPRESENTATION BY USER`,
      paras: [
        {
          para: `The Visitor to the Website represents that the Visitor is legally competent to enter into a binding legal contract and agrees to be bound by these Terms & Conditions.`,
        },
      ],
    },
    {
      id: `tDl4`,
      title: `TERMS AND CONDITIONS FOR USE`,
      paras: [
        {
          para: `This Website is deemed to be in use when it is loaded in a temporary or permanent memory of your computer.`,
        },
      ],
    },
    {
      id: `tDl5`,
      title: `ACCOUNTS AND MEMBERSHIP`,
      paras: [
        {
          para: `If you create an account on the Website, you are responsible for maintaining the security of your account and you are fully responsible for all activities that occur under the account and any other actions taken in connection with it. Providing false contact information of any kind may result in the termination of your account. You must immediately notify us of any unauthorized uses of your account or any other breaches of security. We will not be liable for any acts or omissions by you, including any damages of any kind incurred as a result of such acts or omissions. We may suspend, disable, or delete your account (or any part thereof) if we determine that you have violated any provision of these Terms & Conditions or that your conduct or content would tend to damage our reputation and goodwill, or lead to a violation of the provisions of applicable law. We may block your email address and Internet protocol address to prevent further registration.`,
        },
        {
          para: `All transactions, which cannot be carried out instantaneously, shall be carried out during working hours either on the same day or on the next working day or such further period as may be determined and/or specified by Acko General depending upon the time of logging of the transaction. All transactions that are carried out by and on behalf of the Customer shall be subject to Government notifications, the rules, regulations and guidelines issued by the Insurance Regulatory and Development Authority, the Securities and Exchange Board of India, the Reserve Bank of India, and those of other regulatory bodies defining rules/regulations governing the offer of any service on the Website.`,
        },
      ],
    },
    {
      id: `tDl6`,
      title: `AUTHORITY TO ACKO GENERAL`,
      paras: [
        {
          para: `The Customer hereby authorizes Acko General to carry out his instructions, effecting such transactions as may be permitted by Acko General from time to time, in accordance with these Terms & Conditions and such other terms as may be specified by Acko General.`,
        },
      ],
    },
    {
      id: `tDl7`,
      title: `EVIDENCE OF TRANSACTIONS`,
      paras: [
        {
          para: `For any transaction which may be permitted by Acko General from time to time, Acko General’s own records of such transactions maintained through computer systems or otherwise, shall be accepted as conclusive and binding for all purposes. The record of THE TRANSACTION as generated from the systems of Acko General shall be conclusive proof of the genuineness and accuracy of such transactions.`,
        },
      ],
    },
    {
      id: `tDl8`,
      title: `RESTRICTIONS ON USE`,
      paras: [
        {
          para: `Acko General owns and holds all the rights for the information, contents, audio, video, logos and trademarks contained in this Website. Any reproduction, modification, creation of derivate works, distribution, transmission, copying, selling, displaying, publishing or using any of the information, contents, audio, video, logos and trademarks contained in this Website for any purpose whatsoever, whether electronically or otherwise, without the prior written permission of Acko General is strictly prohibited. Any violation of this provision would be strictly dealt with. You may download material displayed on this Website for your personal use only, provided that you also retain the clauses pertaining to all copyright and other proprietary notices contained in the materials.`,
        },
        {
          para: `User acknowledges and affirms that he/she shall not:`,
        },
        {
          para: `Engage in fraudulent, abusive or illegal activity, including but not limited to any communication or solicitation designed or intended to fraudulently obtain the password or any private information of any use.`,
        },
        {
          para: `Use the Website to violate the security of any computer network, crack pass words or security encryption codes, transfer or store illegal material including threatening or obscene material or engage in any kind of illegal activity.`,
        },
        {
          para: `Although Acko General may, from time to time, monitor or review any facilities, if established or otherwise offered at the Website for discussions, chats, postings, transmissions, bulletin boards, and the like on the Website, Acko General is under no obligation to do so and assumes no responsibility or liability arising from the content of any such locations nor for any error, defamation, libel, slander, omission, falsehood, obscenity, pornography, profanity, danger, or inaccuracy contained in any information contained within such locations on the Website. You are prohibited from posting or transmitting any unlawful, threatening, libelous, defamatory, obscene, scandalous, inflammatory, pornographic, or profane material or any material that could constitute or encourage conduct that would be considered a criminal offense, give rise to civil liability, or otherwise violate any law. Acko General will fully cooperate with any law enforcement authorities or court order requesting or directing Acko General to disclose the identity of anyone posting any such information or materials.`,
        },
      ],
    },
    {
      id: `tDl9`,
      title: `QUOTES`,
      paras: [
        {
          para: `The premium estimate given for private four wheeler & two wheeler is given on the assumption that all previous policies have been renewed continuously without any gap in insurance and no claim has been made in previous policies. The estimate given for other products is approximate and is not final and binding.`,
        },
        {
          para: `The final premium quotation for all products may be viewed by clicking on the “Continue to Buy” tab. You may, at your sole and absolute discretion decide not to proceed with the purchase the policy/product, in the event you do not agree with the final premium quoted by us.`,
        },
        {
          para: `Motor policy should be purchased only if the PUC (Pollution under control) is valid. `,
        },
      ],
    },
    {
      id: `tDl10`,
      title: `CAR INSPECTION`,
      paras: [
        {
          para: `
          1. In case pre-inspection of the vehicle is not completed due to any reason including unavailability of either parties (customer or Acko), customer will be eligible to receive refund of full amount paid towards premium payment;`,
        },
        {
          para: `2. Policy will be issued subject to clearance of pre-inspection criteria at the satisfaction of the Acko. Please be noted that Acko shall not be liable for any risk which may arise before the policy commencement date.`,
        },
        {
          para: `3. Acko reserves a right to reject the proposal even after completion of the pre-inspection of the vehicle, however the customer will be eligible to receive the refund of the full amount paid towards premium payment.`,
        },
      ],
    },
    {
      id: `tDl11`,
      title: `USE OF INFORMATION`,
      paras: [
        {
          para: `The content is available for informational purposes only. The posting of contents and access to this website does not render, either explicitly or implicitly, any provision of services or products by us. All advertisements contain only an indication of cover offered by the products. For more information, please read the policy wordings before concluding a sale.`,
        },
      ],
    },
    {
      id: `tDl12`,
      title: `LINKS TO OTHER WEBSITES`,
      paras: [
        {
          para: `Although this Website may be linked to other websites, we are not, directly or indirectly, implying any approval, association, sponsorship, endorsement, or affiliation with any linked website, unless specifically stated herein. We are not responsible for examining or evaluating, and we do not warrant the offerings of, any businesses or individuals or the content of their websites. We do not assume any responsibility or liability for the actions, products, services, and content of any other third parties. You should carefully review the legal statements and other conditions of use of any website which you access through a link from this Website. Your linking to any other off-site websites is at your own risk.`,
        },
      ],
    },
    {
      id: `tDl13`,
      title: `RESERVATION OF RIGHTS`,
      paras: [
        {
          para: `We reserve the right to change, modify, add to, or remove discounts, portions of these terms of use at any time, subject to IRDAI regulations as amended time to time & Company policy.`,
        },
      ],
    },
    {
      id: `tDl14`,
      title: `PRIVACY POLICY`,
      paras: [
        {
          para: `In the process of using this Website, the Privacy Policy as set forth in the Website www.acko.com shall be applicable.`,
        },
      ],
    },
    {
      id: `tDl15`,
      title: `LIMITATION OF LIABILITY`,
      paras: [
        {
          para: `Under no circumstances, including but not limited to negligence, shall Acko General, its employees and directors, its suppliers and its third party advisors be liable to you for any direct, indirect, incidental, special or consequential damages or any damages whatsoever including punitive or exemplary (including, but not limited to, damages caused by any virus, personal injury, loss of profits, data or other intangible, business interruption, loss of privacy, or any other pecuniary loss), arising out of or in any way connected with the use/delivery/performance of this Website, with the delay or inability to use this website or any links or items on the Website, the provision of or failure to provide services, or for any information, software, products, services and related graphics obtained through this Website, or otherwise arising out of the use of this Website, whether based on contract, tort, strict liability or otherwise, or for cost of procurement of substitute goods and repair & correction services or resulting from the use of this Website or obtained or messages received or transactions entered into through or from the Website or resulting from unauthorized access to or alteration of your transmissions or data, even if we have been advised of the possibility of such damages.`,
        },
        {
          para: `You agree that we shall not be liable for any damages arising from interruption, suspension or termination of the Website, including but not limited to direct, indirect, incidental, special, consequential or exemplary damages, whether such interruption, suspension or termination was justified or not, negligent or intentional, inadvertent or advertent. Applicable law may not allow the limitation or exclusion of liability or incidental or consequential damages. However, in no event shall our liability to you for all damages, losses and causes of action (whether in contract or tort, including but not limited to, negligence) exceed the amount paid by you, if any, for accessing the Website.`,
        },
        {
          para: `Policy/ies are marketed and/or distributed solely by Acko General and are not in any way associated to or being sold, marketed or offered for sale by the Payment Gateway Service provider and the Payment Gateway Service provider shall not be liable for the same.`,
        },
        {
          para: `All transactions that are carried out by and on behalf of the Customer shall be subject to Government notifications, the rules, regulations and guidelines issued by the Insurance Regulatory and Development Authority, the Securities and Exchange Board of India, the Reserve Bank of India, and those of other regulatory bodies defining rules/regulations governing the offer of any service on the Website.`,
        },
        {
          para: `Acko General does not guarantee or warranty that there will be uninterrupted access to and/or use of the Payment and Delivery Mechanism.`,
        },
        {
          para: `Acko General shall not be liable if any transaction does not fructify or may not be completed or for any failure on part of Acko General to perform any of its obligations under these Terms & Conditions or those applicable specifically to its services/facilities if performance is prevented, hindered or delayed by a Force Majeure event (defined below) and in such case its obligations shall be suspended for so long as the Force Majeure event continues.`,
        },
      ],
    },
    {
      id: `tDl16`,
      title: `JURISDICTIONAL ISSUES
      `,
      paras: [
        {
          para: `Unless otherwise expressly set forth herein, Acko General makes no representation that materials on this Website are appropriate or available for use in any location. Those who choose to access this Website do so on their own initiative and are responsible for compliance with local laws. The services/products which are part of the Website do not constitute an offer to sell or a solicitation of an offer to buy any policies/products to any person in any jurisdiction where it is unlawful to make such an offer or solicitation.`,
        },
        {
          para: `However, please note that no person shall take out or renew any policy of insurance in respect of any property in India or any ship or other vessel or aircraft registered in India with an insurer whose principal place of business is outside India without permission of Insurance Regulatory and Development Authority of India.`,
        },
        {
          para: `Except as specifically set forth herein the information contained on this Website is not an offer to sell or any security, insurance product or other product or service. No security, insurance product or other product or service is offered or will be sold in any jurisdiction in which such offer or solicitation, purchase or sale would be unlawful under the securities, insurance or other laws of such jurisdiction. Some products and services may not be available in all jurisdictions. All disputes shall be subject to the exclusive jurisdiction of courts at Mumbai.`,
        },

        {
          para: `Failure on the part of Acko General to enforce any of the provisions hereof will not be construed to be a waiver of the rights vested in Acko General to thereafter enforce such provisions. If any provision of these Terms & Conditions is held to be invalid, illegal or unenforceable, it will be enforced to the maximum extent possible, and the validity, legality and enforceability of the remaining provisions will not in any way be affected or impaired thereby.`,
        },
      ],
    },
    {
      id: `tDl17`,
      title: `NOTICE`,
      paras: [
        {
          para: `Notices under these Terms & Conditions may be given by Acko General to the Customer in writing by delivering them to the last address given by the Customer. Customer may give notice to Acko General by delivering them to the address mentioned on the Website. In the case of hand delivery, cable, telex, facsimile notices or electronic communication notices or instructions will be deemed served 7 days after posting or upon receipt as the case may be. Documents, which may be sent by electronic communication between the parties, may be in the form of an electronic mail, an electronic mail attachment, or in the form of an available download from the Website. Acko General shall be deemed to have fulfilled any legal obligation to deliver to the Customer if any such document is sent via electronic delivery.`,
        },
      ],
    },
    {
      id: `tDl18`,
      title: `MISCELLANEOUS`,
      paras: [
        {
          para: `Acko General’s performance to this Agreement is subject to existing laws and legal process, and nothing contained in this Agreement is in derogation of Acko General’s right to comply with governmental, court and law enforcement directions relating to the use of this Website or information provided to/gathered by Acko General vis-à-vis such use.`,
        },
        {
          para: `Acko General reserves the right to add, amend, revise suspend or cancel in whole or in part any of the services which are, or may become, part of the Website, without any prior notice to the Visitors or Customers. Any addition, suspension, revision, amendment, cancellation or suspension shall be effective and binding on the Visitors and Customers.`,
        },
        {
          para: `Acko General may introduce new services in relation to the Website from time to time. The existence and availability of the new services will be notified on the Website as and when they become available and any revisions in the Terms & Conditions will take place in accordance with these Terms & Conditions. In addition, Acko General may also publish notices of general nature, which are applicable to all Visitors or Customers in a newspaper or on its Website. Such notices will have the same effect as a notice served individually to each Visitor or Customer.`,
        },
        {
          para: `Acko General may transfer or assign its rights and obligations under these Terms & Conditions to any Affiliate.`,
        },
        {
          para: `Acko General shall try and ensure that all information that is provided on the Website with respect to policies / products are accurate in all respects and are kept up to date. However, Acko General does not guarantee the timeliness, accuracy, completeness, reliability or content of the information and any changes that are made with respect to the same and the Visitor/Customer is required to check the accuracy of the same with the office of Acko General.`,
        },
      ],
    },
    {
      id: `tDl19`,
      title: `INSURABLE INTEREST`,
      paras: [
        {
          para: `I declare that the premium paid under this transaction to ACKO General Insurance Limited is being paid by me i.e., the proposer/policyholder through a bank account or a Credit/Debit Card or a Prepaid Payment Instrument or a UPI wallet (Wallet), held by me in my name as a primary holder (referred to as “source account”). I confirm that it is not a third party payment made by any other person on my behalf. I understand that in the event of a policy cancellation, the refund of premium as per policy terms and conditions may be credited back to such source account and such electronic transfer will constitute full and final discharge of the Company’s obligation.`,
        },
      ],
    },
    {
      id: `tDl20`,
      title: `COVID-19 Update:`,
      paras: [
        {
          para: `The novel Coronavirus outbreak might negatively impact our services in the coming days. You might face delays and inconveniences, and we apologise for all of it in advance. Rest assured that we’re working hard to minimise its impact and continue to serve you without letting down our standards. We are grateful for your support and patience in these testing times. Feel free to contact us for any queries or concerns.`,
        },
      ],
    },
    {
        id: `tDl21`,
        title: `MODIFICATION OF THESE TERMS & CONDITIONS`,
        paras: [
          {
            para: `Any addition, suspension, revision, amendment, cancellation or suspension shall be effective and binding on the Visitors and Customers. Acko General may introduce new services in relation to the Website from time to time. The existence and availability of the new services will be notified on the Website as and when they become available and any revisions in the Terms & Conditions will take place in accordance with these Terms & Conditions.`,
          },
        ],
      },
      {
        id: `tDl22`,
        title: `CONTACT`,
        paras: [
          {
            para: `You authorize Acko General to call, send SMS and email on the contact number and email ID (made available by you on our Website) and offer you information and services for the product you have opted for. You authorize us to call, SMS or email you for the mentioned purpose, irrespective of whether you register with the NDNC registry. Acko General may from time to time send by e-mail or otherwise, information relating to products and services offered by its Affiliates, general information related to financial and other services, life and general insurance products.`,
          },
        ],
      },
      {
        id: `tDl23`,
        title: `GRIEVANCES`,
        paras: [
          {
            para: `For grievances, please see Grievance Redressal`,
          },
          {
            para: `Acko General Insurance Limited`,
          },
          {
            para: `Registered Office: 2nd Floor, #36/5, Hustlehub One East, Somasandrapalya, 27th Main Rd, Sector 2, HSR Layout, Bengaluru, Karnataka 560102. `,
          },
          {
            para: `Date of Incorporation: November 3, 2016 `,
          },
          {
            para: `CIN: U66000KA2016PLC138288`,
          },
          {
            para: `IRDAI Registration Number: 157 General Insurance Company `,
          },
          {
            para: `TERMS & CONDITIONS GOVERNING THE USE OF ACKO GENERAL’S WEBSITE BY VISITORS, CUSTOMERS AND REGISTERED USERS.`,
          },
          {
            para: `Copyright © Acko General Insurance Limited. All rights reserved.`,
          },
        ],
      },

  ],
};
export default termsData;
